// ----------------------------------------------------------------------------
// Component: Hero Banner Conversion
// ----------------------------------------------------------------------------

import Swiper, { Pagination, A11y, Keyboard } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

import './_hero-banner-conversion.scss';

const CAROUSEL_SELECTOR = '.hero-banner-conversion__carousel';
const PAGINATION_SELECTOR = '.swiper-pagination';
const CAROUSEL_CLASS = 'hero-banner-conversion__carousel';
const PAGINATION_CLASS = 'hero-banner-conversion__pagination';

document.querySelectorAll(CAROUSEL_SELECTOR).forEach((carousel, index) => {
    const sectionId = carousel.dataset.sectionId || `${index}`;
    const pagination = carousel.querySelector(PAGINATION_SELECTOR);

    if (!pagination) {
        return;
    }

    carousel.classList.add(`${CAROUSEL_CLASS}-${sectionId}`);
    pagination.classList.add(`${PAGINATION_CLASS}-${sectionId}`);

    let swiper = null;
    const tabletQuery = window.matchMedia('(min-width: 788px)');

    // eslint-disable-next-line no-unused-vars
    const initSwiper = () => {
        if (swiper !== null) {
            return;
        }

        swiper = new Swiper(`.${CAROUSEL_CLASS}-${sectionId}`, {
            modules: [Pagination, A11y, Keyboard],
            slidesPerView: 1.3,
            spaceBetween: 2,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true,
            pagination: {
                el: `.${PAGINATION_CLASS}-${sectionId}`,
                type: 'bullets',
                clickable: true
            }
        });
    };

    const destroySwiper = () => {
        if (swiper === null) {
            return;
        }

        swiper.destroy(true, true);
        swiper = null;
    };

    const syncMode = () => {
        if (tabletQuery.matches) {
            destroySwiper();
        }
    };

    syncMode();

    if (tabletQuery.addEventListener) {
        tabletQuery.addEventListener('change', syncMode);
    } else {
        tabletQuery.addListener(syncMode);
    }
});
